import React from "react";
import { ArrowDown } from "lucide-react";
import { HOMESTAY } from "@/lib/data";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden"
    >
      <img
        src="https://customer-assets.emergentagent.com/job_cozy-nandi-escape/artifacts/5msx5zmt_Screenshot%202026-05-04%20at%2012.45.06%20PM.png"
        alt="Sunrise above the clouds over Nandi Hills — view from Mrinmaya vacation home"
        className="absolute inset-0 w-full h-full object-cover scale-x-[-1]"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/25 to-[#3B2A20]/80" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 pt-40 md:pt-48 pb-16 min-h-[100svh] flex flex-col">
        <p
          data-testid="hero-eyebrow"
          className="anim-rise text-mrn-sand tracking-[0.35em] text-xs md:text-sm uppercase font-medium"
        >
          A rustic homestay · Nandi Hills · Chikkaballapura
        </p>

        <h1
          data-testid="hero-headline"
          className="anim-rise-1 headline-display mt-8 text-mrn-cream text-[3.2rem] sm:text-7xl lg:text-[7.5rem] max-w-5xl"
        >
          Mountains,
          <br />
          Movie&nbsp;Nights,
          <br />
          <span className="italic font-light text-mrn-sand">Memories.</span>
        </h1>

        <p
          data-testid="hero-sub"
          className="anim-rise-2 mt-10 text-mrn-cream/90 text-base md:text-lg max-w-xl leading-relaxed"
        >
          A 3-bedroom open-brick villa at the foothills of Nandi Hills. Open-air IPL
          screenings, bonfire evenings, sunrise — all 90 minutes from Bangalore.
        </p>

        <div className="anim-rise-3 mt-10 flex flex-wrap items-center gap-4">
          <a
            href="#inquiry"
            data-testid="hero-enquire-btn"
            className="mrn-pill mrn-pill-primary"
          >
            Enquire for dates
          </a>
          <a
            href="#inquiry"
            data-testid="hero-airbnb-btn"
            className="mrn-pill mrn-pill-ghost"
          >
            Talk to us →
          </a>
        </div>

        <div className="mt-auto pt-16 flex items-end justify-between">
          <div className="hidden md:flex flex-col gap-1 text-mrn-cream/80 text-sm">
            <span className="font-accent text-2xl text-mrn-sand">3 bedrooms</span>
            <span className="tracking-widest text-xs uppercase">6 beds · sleeps 12</span>
          </div>
          <div className="flex items-center gap-3 text-mrn-cream/75 text-xs tracking-[0.3em] uppercase">
            <span>Scroll</span>
            <ArrowDown size={16} className="animate-bounce" />
          </div>
        </div>
      </div>
    </section>
  );
}
